<template>
  <div class="leftPublicTree" v-loading="loading">
   <div class="searchBox">
     <el-input
         size="small"
         placeholder="输入关键字进行过滤"
         v-model="filterText">
     </el-input>
   </div>

    <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        node-key="id"
        default-expand-all
        highlight-current
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
        @node-click="nodeClick"
        ref="tree">
       <div class="custom-tree-node" slot-scope="{ node, data }">
        <div class="name ellipsis" :title="node.label">{{ node.label }}</div>
        <div class="addPerson" @click="openAddPerson(data)" v-if="!data.childList && checkAuth('add')">
          <i class="el-icon-circle-plus"></i>
          <span>添加人员</span>
        </div>
      </div>
    </el-tree>
    <addPerson ref="addPerson" :triggerUpdatePersonList="triggerUpdatePersonList" type="interior"></addPerson>
  </div>
</template>

<script>
import request from '@/xgzdService/prjMember-service'
import { mapState } from 'vuex'
import addPerson from '@/views/project/prjMember/components/addPerson/addPerson'
import {checkAuth} from '../utils'
export default {
  name:'leftPublicTree',

  props:['type','updatePersonList'],

  data () {
    return {
      filterText: '',
      data: [],
      defaultProps: {
        children: 'childList',
        label: 'roleName'
      },
      loading:false,
      currentTreeData:{}
    }
  },

  components : {
    addPerson
  },

  created () {
    this.loading = true
    if (this.type === 'interior') {     //内部
      this.queryInteriorTree()
    } else {  //外部
      this.queryExternalTree()
    }
  },

  methods : {
    checkAuth,
    /**
     * 查询内部成员左侧树
     */
    queryInteriorTree () {
      const {prjId} = this.prjObj
      return request.queryInteriorTree(prjId)
      .then(res => {
        if (res.result === '0') {
          res.data = res.data || []
          this.data = res.data
          this.loading = false
          this.setCurrentTreeData(res.data)
        }
      })
      .catch(e => {
        this.loading = false
        this.$message.warning(e.message || '查询内部树失败')
      })
    },

    /**
     * 设置默认选中节点并且查询数据
     */
    async setCurrentTreeData (data) {
      if (!data) return
      const [firstData] = data
      if (!firstData) return
      const {childList} = firstData
      if (!childList) return
      const [firstChild] = childList
      if (!firstChild) return
      this.currentTreeData = firstChild
      await this.$nextTick(() => {})
      this.$refs.tree.setCurrentKey(firstChild.id)
      this.queryRolePersonList(firstChild)
    },

    /**
     * 查询内部成员左侧树
     */
    queryExternalTree () {
      const {prjId} = this.prjObj
      return request.queryExternalTree(prjId)
      .then(res => {
        if (res.result === '0') {
          res.data = res.data || []
          this.data = res.data
          this.loading = false
          this.setCurrentTreeData(res.data)
        }
      })
      .catch(e => {
        this.loading = false
        this.$message.warning(e.message || '查询外部树失败')
      })
    },

    /**
     * 触发父节点方法，查询角色下对应的成员列表
     * @param data  当前点击的树节点
     */
    queryRolePersonList (data) {
      const {roleID:roleId} = data
      const {prjId} = this.prjObj
      this.updatePersonList({prjId,roleId})
    },

    /**
     * 左侧树点击事件回调
     * @param data
     */
    nodeClick (data) {
      this.queryRolePersonList(data)
    },

    /**
     *
     * @param value  关键字value
     * @param data 当前节点
     * @returns {boolean}
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },

    /**
     * 打开添加人员
     */
    openAddPerson (data) {
      this.currentTreeData = data
      let showType = ''
      const {parent} = this.$refs.tree.getNode(data)
      if (parent.data.roleItemCode === '2') {
        showType = 'all'
      } else {
        showType = this.type === 'interior' ? 'interior' : 'external'
      }
      this.$refs.addPerson.updateShowType(showType)
      this.$refs.addPerson.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addPerson.reset()
      })
    },

    /**
     * 确定添加数据后刷新列表
     */
    async triggerUpdatePersonList (checkUsers) {
      const requestType = this.type === 'interior' ? 'addInteriorPerson' : 'addExternalPerson'
      const {prjId} = this.prjObj
      const {roleID:roleId,roleName} = this.currentTreeData
      const userIdList = checkUsers.map(item => item.userId)
      try {
        const res = await request[requestType]({prjId,roleId,roleName,userIdList})
        if (res.result === '0') {
          this.$refs.addPerson.confirmLoading = false
          this.$refs.addPerson.dialogVisible = false
          this.queryRolePersonList(this.currentTreeData)
        }
      } catch (e) {
        this.$refs.addPerson.confirmLoading = false
        this.$message.warning(e.message || '添加失败')
      }
    },
  },

  computed : {
    ...mapState({
      prjObj : state => state.projectMg.prjObj
    })
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .leftPublicTree
    width:17%;
    height: 100%
    border-right 1px solid #E5E8F1
    .searchBox
      height 56px
      border-bottom: 1px solid #E5E8F1
      display flex
      align-items center
      padding 0 15px
      box-sizing border-box
      margin-bottom 10px
    /deep/ .el-tree
              height calc(100% - 67px)
              overflow-y auto
              .el-tree-node:focus > .el-tree-node__content {
                background-color:  rgba(38, 95, 206, 0.09);
              }
              .el-tree-node__content:hover {
                background-color: rgba(38, 95, 206, 0.09);
              }
              .custom-tree-node
                width 80%
                display flex
                align-items center
                .name
                  min-width 0
                  flex-grow: 1
                .addPerson
                  display flex
                  align-items center
                  justify-content flex-start
                  width: 90px
                  i
                    color #5584FF
                    font-size 18px
                    display none
                  span
                    display none
              .custom-tree-node:hover .addPerson>i
                  display inline-block
              .custom-tree-node:hover .addPerson>span
                  display inline-block

</style>
